import { createStore } from "vuex";

const APP_LOCALE = process.env.MIX_APP_LOCALE || "pl";

const store = createStore({
    state: {
        monthly_payment: 0,
        annual_consumption: 0,
        installation_size: 0,
        roof_type: "",
        form: {},
        price: 0,
        base_price: 0,
        options: {
            panel_type: "glass-foil",
            financing: "cash",
            power_optimizers: false,
            full_black: false,
            microinverters: false,
            panels_number: 0,
            vision_surcharge: 0,
            full_black_surcharge: 0,
            optimizers_surcharge: 0,
            microinverters_surcharge: 0,
        },
    },
    mutations: {
        SET_MONTHLY_PAYMENT(state, value) {
            state.monthly_payment = value;
        },
        SET_ROOF_TYPE(state, value) {
            state.roof_type = value;
        },
        SET_PRICE(state, value) {
            state.price = value;
        },
        SET_BASE_PRICE(state, value) {
            state.base_price = value;
        },
        SET_OPTIONS(state, value) {
            state.options = value;
            let glassFoilWp = APP_LOCALE === "nl" ? 375 : 360;
            let glassGlassWp = APP_LOCALE === "nl" ? 320 : 315;
            let panelsNumberOptions = {
                "glass-glass": Math.ceil(
                    state.annual_consumption / glassGlassWp
                ),
                "glass-foil": Math.ceil(state.annual_consumption / glassFoilWp),
            };
            let installationSizeOptions = {
                "glass-glass":
                    (panelsNumberOptions["glass-glass"] * glassGlassWp) / 1000,
                "glass-foil":
                    (panelsNumberOptions["glass-foil"] * glassFoilWp) / 1000,
            };
            let panelPriceOptions = {
                "glass-glass": panelsNumberOptions["glass-glass"] * 125,
                "glass-foil": panelsNumberOptions["glass-foil"] * 103,
            };
            let visionSurchargeMultiplier = APP_LOCALE === "nl" ? 2.5 : 6;
            let currencyMultiplier = APP_LOCALE === "nl" ? 1 : 4.56;
            state.installation_size = installationSizeOptions[value.panel_type];
            state.options.panels_number = panelsNumberOptions[value.panel_type];
            state.options.vision_surcharge =
                (panelPriceOptions["glass-glass"] -
                    panelPriceOptions["glass-foil"]) *
                visionSurchargeMultiplier;
            state.options.full_black_surcharge =
                panelsNumberOptions[value.panel_type] * 15 * currencyMultiplier;
            state.options.optimizers_surcharge =
                panelsNumberOptions[value.panel_type] * 65 * currencyMultiplier;
            state.options.microinverters_surcharge =
                panelsNumberOptions[value.panel_type] *
                100 *
                currencyMultiplier;
        },
        SET_INSTALLATION_SIZE(state, value) {
            state.installation_size = value;
        },
        SET_ANNUAL_CONSUMPTION(state, value) {
            state.annual_consumption = value;
        },
    },
    getters: {
        monthly_payment: (state) => {
            return state.monthly_payment;
        },
        roof_type: (state) => {
            return state.roof_type;
        },
        price: (state) => {
            return state.price;
        },
        base_price: (state) => {
            return state.base_price;
        },
        options: (state) => {
            return state.options;
        },
        annual_consumption: (state) => {
            return state.annual_consumption;
        },
        installation_size: (state) => {
            return state.installation_size;
        },
    },
    actions: {
        setMonthlyPayment({ commit }, amount) {
            commit("SET_MONTHLY_PAYMENT", amount);
        },
        setAnnualConsumption({ commit }, amount) {
            commit("SET_ANNUAL_CONSUMPTION", amount);
        },
        setRoofType({ commit }, type) {
            commit("SET_ROOF_TYPE", type);
        },
        setPrice({ commit }, type) {
            commit("SET_PRICE", type);
        },
        setBasePrice({ commit }, type) {
            commit("SET_BASE_PRICE", type);
        },
        setOptions({ commit }, type) {
            commit("SET_OPTIONS", type);
        },
        setInstallationSize({ commit }, type) {
            commit("SET_INSTALLATION_SIZE", type);
        },
    },
});

export default store;
